module.exports = __webpack_public_path__ + "img/randomimage (2).ba2ad2ae.png";